import { Component, OnInit } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd";
import { LegalEntity } from "@app/_models/_DTOs/legalEntity";
import { LegalEntityService } from "@app/_services/legalEntity.service";
import { ITuple } from "@app/_models/tuple";
import { Sort } from "@app/_models/sort";
import { SortDirection } from "@app/_models/enums/sortDirection";
import { LegalEntityViewModel } from "@app/_models/_viewModels/legalEntity.viewmodel";
import { BaseComponent } from "@app/_shared/base.component";
import { SCREEN_SIZE } from "@app/_helpers/screen-size.enum";
import { UserToken } from "@app/_models";
import { AuthenticationService } from "@app/_services";
import { ResizeService } from "@app/_services/resize.service";

@Component({
  selector: "app-legal-entities",
  templateUrl: "./legal-entities.component.html",
  styleUrls: ["./legal-entities.component.css"],
})
export class LegalEntitiesComponent extends BaseComponent implements OnInit {
  onScreenResize(screenSize: SCREEN_SIZE) {}
  onUserAvailable(userToken: UserToken) {}
  level: number = 0;

  sorts: Sort[] = [];
  pageIndex = 1;
  pageSize = 10;
  total = 1;
  legalEntityList: LegalEntity[] = [];
  loading = true;

  detailsDrawerVisible: boolean = false;
  editDrawerVisible: boolean = false;
  isSavingLegalEntity: boolean = false;
  isEditing: boolean = false;

  selectedLegalEntity: LegalEntity;
  legalEntityViewModel: LegalEntityViewModel = null;

  nameSearchValue = "";
  prefixSearchValue = "";

  errorMessages = {};

  constructor(
    private legalEntityService: LegalEntityService,
    private messageService: NzMessageService,
    protected authenticationService: AuthenticationService,
    protected resizeService: ResizeService
  ) {
    super(authenticationService, resizeService);
  }

  ngOnInit() {
    this.searchData();
  }

  initModel(legalEntity?: LegalEntity) {
    if (legalEntity) {
      this.isEditing = true;
      this.legalEntityViewModel = {
        id: legalEntity.id ? legalEntity.id : -1,
        name: legalEntity.name ? legalEntity.name : "",
        inventoryPrefix: legalEntity.inventoryPrefix
          ? legalEntity.inventoryPrefix
          : "",
      };
    } else {
      this.isEditing = false;
      this.legalEntityViewModel = {
        id: -1,
        name: "",
        inventoryPrefix: "",
      };
    }
  }

  openCreateLegalEntityForm() {
    this.isEditing = false;
    this.initModel();
  }

  editLegalEntity(legalEntity: LegalEntity) {
    this.initModel(legalEntity);
  }

  deleteLegalEntity(id: number) {
    this.legalEntityService.delete(id).subscribe(
      (result) => {
        this.messageService.create("success", "Pravna osoba uspješno obrisana");
        this.searchData();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  sort(sort: { key: string; value: string }): void {
    var newSort: Sort = {
      PropertyName: sort.key,
      Direction: null,
    };
    if (sort.value) {
      if (sort.value == "ascend") {
        newSort.Direction = SortDirection.Ascending;
      } else {
        newSort.Direction = SortDirection.Descending;
      }
    }

    if (newSort.Direction == null) {
      var existingSort = this.sorts.find(
        (x) => x.PropertyName == newSort.PropertyName
      );
      if (existingSort) {
        const index = this.sorts.indexOf(existingSort);
        if (index > -1) {
          this.sorts.splice(index, 1);
        }
      }
    } else {
      var existingSort = this.sorts.find(
        (x) => x.PropertyName == newSort.PropertyName
      );
      if (existingSort) {
        existingSort.Direction = newSort.Direction;
      } else {
        this.sorts.push(newSort);
      }
    }
    this.searchData();
  }

  getSortString() {
    var sortString = "";
    if (this.sorts && this.sorts.length > 0) {
      for (let sort of this.sorts) {
        if (sort.Direction == SortDirection.Ascending) {
          if (sortString.length == 0) {
            sortString = sort.PropertyName;
          } else {
            sortString += "," + sort.PropertyName;
          }
        } else {
          if (sortString.length == 0) {
            sortString = "-" + sort.PropertyName;
          } else {
            sortString += ",-" + sort.PropertyName;
          }
        }
      }
    }
    return sortString;
  }

  searchData(reset: boolean = false): void {
    if (reset) {
      this.pageIndex = 1;
    }

    var filters = "";
    if (this.nameSearchValue.length > 0) {
      filters += "Name@=" + this.nameSearchValue + ",";
    }
    if (this.prefixSearchValue.length > 0) {
      filters += "InventoryPrefix@=" + this.prefixSearchValue + ",";
    }

    var sortString = this.getSortString();
    if (sortString.length == 0) {
      sortString = "-Created";
    } else {
      sortString += ",-Created";
    }

    this.loading = true;
    this.legalEntityService
      .getPage(this.pageIndex, this.pageSize, sortString, filters)
      .subscribe((data: ITuple<LegalEntity>) => {
        this.loading = false;
        this.total = data.item2;
        this.legalEntityList = data.item1;
      });
  }

  reset(): void {
    this.nameSearchValue = "";
    this.prefixSearchValue = "";
    this.searchData(true);
  }

  openDetails(legalEntity: LegalEntity) {
    // this.legalEntityService
    //   .get(legalEntity.id)
    //   .subscribe((data: LegalEntity) => {
    //     this.selectedLegalEntity = data;
    //   });
  }

  closeDetails() {
    this.selectedLegalEntity = null;
  }

  closeEditDrawer(reload: boolean) {
    this.legalEntityViewModel = null;
    this.isEditing = false;
    if (reload) {
      this.searchData();
    }
  }
}
